define(['lodash'], function (_) {
    'use strict';

    const getter = (dataPath, {clientSpec}) => _.get(clientSpec, dataPath);

    return {clientSpec: getter};
});
